import React from "react";

import { useTranslation } from "react-i18next";

import { Button, DatePicker, Divider, Form, Input, Modal, Select, Spin } from "antd";

import { useDispatch, useSelector } from "react-redux";

import slice from "./reducer";
import saga from "./saga";

import { makeSelectLoading, makeSelectOpen } from "./selectors";

import useInjectSaga from "../../utils/useInjectSaga";
import { makeSelectLanguage } from "../../containers/App/selectors";
import { MessageContactTypes } from "../../dto/Message/MessageDto";
import { MessageUtils } from "../../viewModels/Message/MessageModel";
import dayjs from "dayjs";

export type CreateMessageFormInput = {
  contactType: MessageContactTypes;
  comment: string;
  nextContactDate?: dayjs.Dayjs;
};

const CreateMessageModal = React.memo(() => {
  const { t } = useTranslation("translations");

  const lang = useSelector(makeSelectLanguage());

  useInjectSaga("createMessageModal", saga);

  const dispatch = useDispatch();

  const open = useSelector(makeSelectOpen);
  const loading = useSelector(makeSelectLoading);

  const handleClose = React.useCallback(() => {
    dispatch(slice.actions.closeModal());
  }, [dispatch]);

  const handleFinish = React.useCallback(
    (model: CreateMessageFormInput) => {
      dispatch(slice.actions.createMessage(model));
    },
    [dispatch],
  );

  return (
    <Modal open={open} onCancel={handleClose} footer={null} destroyOnHidden title={t("new_contact")}>
      <Spin spinning={loading}>
        <Form
          layout="vertical"
          initialValues={{
            contactType: "PHONE",
          }}
          onFinish={handleFinish}
        >
          <Form.Item name="contactType" label={t("contact_type")}>
            <Select
              options={[
                { value: "PHONE", label: MessageUtils.getContactTypeLabel("PHONE", lang) },
                { value: "EMAIL", label: MessageUtils.getContactTypeLabel("EMAIL", lang) },
                { value: "MESSENGER", label: MessageUtils.getContactTypeLabel("MESSENGER", lang) },
                { value: "OTHER", label: MessageUtils.getContactTypeLabel("OTHER", lang) },
              ]}
            />
          </Form.Item>

          <Form.Item name="comment" label={t("comment")} rules={[{ required: true, message: t("enter_comment") }]}>
            <Input.TextArea autoSize />
          </Form.Item>

          <Form.Item name="nextContactDate" label={t("next_contact_date")}>
            <DatePicker placeholder="" style={{ width: "100%" }} format={"DD MMMM YYYY"} />
          </Form.Item>

          <Divider />

          <Button htmlType="submit" type="primary">
            {t("create")}
          </Button>
        </Form>
      </Spin>
    </Modal>
  );
});

export default CreateMessageModal;
